import { FC, SVGProps } from 'react';

export const Persone2Icon: FC<SVGProps<SVGSVGElement>> = ({ ...props }) => (
  <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <ellipse cx="6" cy="9.25" rx="3.5" ry="1.75" stroke="#141414" strokeLinejoin="round" />
    <circle cx="6" cy="4" r="2" stroke="#141414" strokeLinejoin="round" />
  </svg>
);
